import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoSettings } from 'react-icons/io5';

export default function AddExam() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [facultyCount, setFacultyCount] = useState(1); // Default to 1
  const [selectionType, setSelectionType] = useState('one'); // State to hold "One" or "Many" selection
  const focusInputRef = useRef(null); // Ref for the username input
  const [subjects, setSubjects] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const currentPath = location?.pathname || '';

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();
  }, [navigate]);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    // Fetch subjects
    axios
      .get(`${apiUrl}/api/subject`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        setSubjects(res.data.subjects);
      })
      .catch((err) => {
        console.log(err);
        err.response?.status === 401 && navigate('/');
      });

    // Fetch programs
    axios
      .get(`${apiUrl}/api/program/`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        setPrograms(res.data.programs);
      })
      .catch((err) => {
        console.log(err);
        err.response?.status === 401 && navigate('/');
      });
  }, [apiUrl, navigate]);

  const [formData, setFormData] = useState({
    name: '',
    programId: '',
    isLocked: false,
    subjects: [
      {
        subjectId: '',
        totalMarks: '',
        passingMarks: '',
        internalTotalMark: '',
        internalPassMark: '',
        omrMarks: '',
        isOmrMarks: false,
      },
    ],
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const token = localStorage.getItem('token');

    // Filter out subjects without subjectId
    const selectedSubjects = formData.subjects.filter(
      (subject) => subject.subjectId !== ''
    );

    const payload = {
      name: formData.name,
      facultyCount: facultyCount,
      programId: +formData.programId,
      isLocked: false,
      subjects: selectedSubjects.map((subject) => ({
        subjectId: subject.subjectId,
        totalMarks: +subject.totalMarks,
        passingMarks: +subject.passingMarks,
        internalTotalMark: +subject.internalTotalMark,
        internalPassMark: +subject.internalPassMark,
        omrTotalMark: +subject.omrMarks > 0 ? +subject.omrMarks : null,
        isOmrMarks: subject.omrMarks > 0 ? true : false,
      })),
    };

    axios
      .post(`${apiUrl}/api/exam`, payload, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        setIsLoading(false);
        toast.success('Exam added successfully');
        focus();

        // Reset form state
        setFormData({
          name: '',
          programId: '',
          subjects: [
            {
              subjectId: '',
              totalMarks: '',
              passingMarks: '',
              internalTotalMark: '',
              internalPassMark: '',
              omrMarks: '',
              isOmrMarks: false,
            },
          ],
        });
        setFacultyCount(1);

        // Navigate to ListExam after a timeout if conditions match
        if (selectionType === 'one' && currentPath === '/AddExam') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/AddExam') {
              navigate('/ListExam');
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.message);
        err.response?.status === 401 && navigate('/');
      });
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      subjects: prevState.subjects.map((subject, i) =>
        i === index ? { ...subject, [name]: value } : subject
      ),
    }));
  };

  const handleSubjectChange = (index, e) => {
    const { value } = e.target;
    const updatedSubjects = [...formData.subjects];
    updatedSubjects[index].subjectId = parseInt(value);
    setFormData((prevState) => ({
      ...prevState,
      subjects: updatedSubjects,
    }));
  };

  const addSubject = () => {
    setFormData((prevState) => ({
      ...prevState,
      subjects: [
        ...prevState.subjects,
        {
          subjectId: '',
          totalMarks: '',
          passingMarks: '',
          internalTotalMark: '',
          internalPassMark: '',
          omrMarks: '',
          isOmrMarks: false,
        },
      ],
    }));
  };

  const removeSubject = (index) => {
    setFormData((prevState) => {
      const updatedSubjects = [...prevState.subjects];
      updatedSubjects.splice(index, 1);
      return {
        ...prevState,
        subjects: updatedSubjects,
      };
    });
  };

  const getAvailableSubjects = (index) => {
    const selectedSubjectIds = formData.subjects
      .map((subject) => subject.subjectId)
      .filter((id) => id !== '');
    return subjects.filter(
      (subject) =>
        !selectedSubjectIds.includes(subject.id) ||
        formData.subjects[index].subjectId === subject.id
    );
  };

  return (
    <>
      <AdminLayout ac4="active">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Add New Exams </li>
              </ol>
            </nav>
          </div>

          <section className="section col-lg-12">
            <div className="row">
              <div className="card">
                <div className="card-body mt-5 mb-1 mx-1 p-0">
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="container text-center mx-1">
                        <div className="row row-cols-1">
                          <div className="col">
                            <div className="row">
                              <div className="col-6">
                                <div className="form-floating mb-2">
                                  <input
                                    ref={focusInputRef}
                                    className="form-control"
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        name: e.target.value,
                                      })
                                    }
                                    placeholder="Exam Name"
                                    onKeyDown={(e) => {
                                      if (e.key === '.') {
                                        e.preventDefault();
                                      }
                                    }}
                                    required
                                  />
                                  <label
                                    className="form-label"
                                    htmlFor="txtGrNo"
                                  >
                                    Exam Name{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-floating mb-2">
                                  <select
                                    className="form-select"
                                    name="programId"
                                    value={formData.programId}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        programId: e.target.value,
                                      })
                                    }
                                    required
                                  >
                                    <option value="">Select Program</option>
                                    {programs.map((program) => (
                                      <option
                                        key={program.id}
                                        value={program.id}
                                      >
                                        {program.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label
                                    className="form-label"
                                    htmlFor="txtGrNo"
                                  >
                                    Program{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="container mx-3 mb-1">
                      {formData.subjects.map((subject, index) => (
                        <div
                          className="row gx-3 align-items-center"
                          key={index}
                        >
                          {/* Subject Selection */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger ">
                              Select Subject*
                            </label>
                            <div className="form-floating">
                              <select
                                className="form-select"
                                value={subject.subjectId}
                                onChange={(e) => handleSubjectChange(index, e)}
                              >
                                <option value="">Select </option>
                                {getAvailableSubjects(index).map((subject) => (
                                  <option key={subject.id} value={subject.id}>
                                    {subject.name} ({subject.subjectCode})
                                  </option>
                                ))}
                              </select>
                              <label className="form-label">
                                Subject <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>

                          {/* External Exam */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger">
                              External Exam*
                            </label>
                            <div className="d-flex">
                              <div className="form-floating me-2">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="totalMarks"
                                  value={subject.totalMarks}
                                  onChange={(e) => handleChange(e, index)}
                                  placeholder="Total Marks"
                                  required
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Total Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-floating">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="passingMarks"
                                  value={subject.passingMarks}
                                  onChange={(e) => handleChange(e, index)}
                                  placeholder="Passing Marks"
                                  required
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Passing Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Internal Exam */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger">
                              Internal Exam*
                            </label>
                            <div className="d-flex">
                              <div className="form-floating me-2">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="internalTotalMark"
                                  value={subject.internalTotalMark}
                                  onChange={(e) => handleChange(e, index)}
                                  placeholder="Internal Total Marks"
                                  required
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Total Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-floating">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="internalPassMark"
                                  value={subject.internalPassMark}
                                  onChange={(e) => handleChange(e, index)}
                                  placeholder="Internal Passing Marks"
                                  required
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Passing Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* OMR */}
                          <div className="col-md-2 text-center">
                            <label className="text-danger">OMR Marks</label>
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="number"
                                name="omrMarks"
                                min={0}
                                value={subject.omrMarks}
                                onChange={(e) => handleChange(e, index)}
                                placeholder="OMR Marks"
                                onWheel={(e) => e.target.blur()}
                              />
                              <label className="form-label form-label-exam">
                                OMR Marks <span className="text-danger"></span>
                              </label>
                            </div>
                          </div>

                          {/* Remove Button */}
                          <div className="col-md-1 text-center">
                            <button
                              type="button"
                              className="btn btn-danger exam-remove-button"
                              onClick={() => removeSubject(index)}
                            >
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row text-end button-add-exam ">
                      <div className="d-flex flex-row  justify-content-end  mx-3">
                        <div className="p-2 mt-2">
                          <label>
                            <IoSettings size={25} className="pb-1" />{' '}
                            <strong>
                              Allcation Setting for Faculties
                            </strong>{' '}
                          </label>
                        </div>
                        <div className="p-2 col-1">
                          <select
                            className="form-select "
                            value={facultyCount}
                            onChange={(e) =>
                              setFacultyCount(parseInt(e.target.value))
                            }
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                          </select>
                        </div>
                        <div className="p-2 ">
                          <button
                            type="button"
                            className="btn btn-primary justify-content-end "
                            onClick={addSubject}
                          >
                            <i className="bi bi-journal-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="d-flex justify-content-between ">
                        <div className="p-2  mx-3 bd-highlight">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input recode-switch"
                              type="checkbox"
                              id="selectionSwitch"
                              checked={selectionType === 'many'}
                              onChange={() =>
                                setSelectionType(
                                  selectionType === 'many' ? 'one' : 'many'
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="selectionSwitch"
                            >
                              {selectionType === 'many'
                                ? 'Many Exam Add'
                                : 'One Exam Add'}
                            </label>
                          </div>
                        </div>
                        <div className="p-2  bd-highlight">
                          <button
                            type="button"
                            className="btn btn-primary px-3"
                            onClick={() => navigate(-1)}
                          >
                            <i className="bi bi-arrow-bar-left"></i> Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary px-4 mx-2"
                            disabled={isLoading}
                          >
                            {isLoading ? 'Saving...' : 'Save'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <ToastContainer
                    position="top-center"
                    style={{ width: 'auto' }}
                  />
                </div>
              </div>
            </div>
          </section>
        </main>
      </AdminLayout>
    </>
  );
}
